import { PopoverButton } from "./popover-button";
import { toolboxFlowsTriggerButtons } from "./constants";
import JourneySlotHandleDialog from "../../../components/journey-slot-handle-dialog";
import { useState, useEffect, useContext } from "react";
import { getAgentAction } from "../../../services/prompt-ai";
import { WorkflowCanvasContext } from "../../../contexts/WorkflowCanvasContextProvider";
import TextToWorkflowModel from "../../text-to-workflow";
import { GEN_AI_TEXT_TO_WF, GEN_AI_TEXT_TO_WF_EDIT } from "../../../consts/gen-ai-consts";
import { connect } from "react-redux";

// Local storage key for auto save preference
const AUTO_SAVE_STORAGE_KEY = 'botcircuits-auto-save-preference';

function Toolbox({ appId, journeyId, onSlotsUpdated, stmSlotCreateRequestMessage }) {
  const workflowContext = useContext(WorkflowCanvasContext);
  const [currentEvent, setCurrentEvent] = useState();
  const [actionConfig, setActionConfig] = useState({ name: '...' });
  const [autoSave, setAutoSave] = useState(false);

  const onEventTrigger = event => {
    console.log('onEventTrigger', event)
    if (event === 'save') {
      handleSave();
      return;
    }
    setCurrentEvent(event)
  }

  const [dataLoadingState, setDataLoading] = useState({
    processing: false,
    success: false,
    failed: false,
    message: null,
  });

  const updateDataLoadingState = (processing, success, failed, message) => {
    setDataLoading({ processing, success, failed, message });
  };

  const fetchActionConfig = async () => {
    updateDataLoadingState(true, false, false);
    const resp = await getAgentAction(appId, journeyId);
    if (resp) {
      setActionConfig(resp)
    }
    updateDataLoadingState(false, true, false);
  }

  const onDragStart = (event, nodeData) => {
    workflowContext.onDragStart(event, nodeData)
  }

  const handleSave = () => {
    // Call the save functionality from the workflow context
    if (workflowContext && workflowContext.saveWorkflow) {
      workflowContext.saveWorkflow(false);
    }
  }

  const handleAutoSaveChange = (e) => {
    const isChecked = e.target.checked;
    setAutoSave(isChecked);

    // Save to localStorage
    localStorage.setItem(AUTO_SAVE_STORAGE_KEY, JSON.stringify(isChecked));

    // If there's an autoSave handler in the workflow context, call it
    if (workflowContext && workflowContext.setAutoSave) {
      workflowContext.setAutoSave(isChecked);
    }
  }

  // Load auto save preference from localStorage on component mount
  useEffect(() => {
    try {
      const savedAutoSave = localStorage.getItem(AUTO_SAVE_STORAGE_KEY);
      if (savedAutoSave !== null) {
        const parsedValue = JSON.parse(savedAutoSave);
        setAutoSave(parsedValue);

        // Update the workflow context with the saved preference
        if (workflowContext && workflowContext.setAutoSave) {
          workflowContext.setAutoSave(parsedValue);
        }
      }
    } catch (error) {
      console.error('Error loading auto save preference from localStorage:', error);
    }
  }, [workflowContext]);

  useEffect(() => {
    if (journeyId) {
      fetchActionConfig();
    }
  }, [journeyId]);

  return (
    <div className="grid grid-cols-3 border-b dark:border-gray-700">
      <div className="pt-5 pl-4 capitalize font-semibold dark:font-semibold text-sm xl:text-lg dark:text-white text-gray-500">
        <p>{actionConfig.name}</p>
      </div>
      <menu className="flex items-center w-full justify-center">
        {toolboxFlowsTriggerButtons.map((button, index) => {
          return <PopoverButton key={index} option={button} eventTrigger={onEventTrigger} onDragStart={onDragStart} />;
        })}
        {/* Auto Save Toggle */}
        {toolboxFlowsTriggerButtons.some(btn => btn.id === "save-workflow") && (
          <div className="flex items-center ml-2">
            <label className="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={autoSave}
                onChange={handleAutoSaveChange}
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-gray-300 dark:peer-focus:ring-gray-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-primary"></div>
              <span className="ms-3 text-xs font-medium text-gray-600 dark:text-gray-300 whitespace-nowrap">Auto Save</span>
            </label>
          </div>
        )}
        {(currentEvent === 'variable' || stmSlotCreateRequestMessage) &&
          <JourneySlotHandleDialog
            appId={appId}
            journeyId={journeyId}
            onSlotsUpdated={onSlotsUpdated}
            stmSlotCreateRequestMessage={stmSlotCreateRequestMessage}
            onContainerClose={() => {
              setCurrentEvent(null);
            }}
          />
        }

        {(actionConfig.id && (currentEvent === GEN_AI_TEXT_TO_WF || currentEvent === GEN_AI_TEXT_TO_WF_EDIT)) &&
          <TextToWorkflowModel
            journeyId={actionConfig.id}
            event={currentEvent}
            onCompletion={() => { setCurrentEvent(null) }}
            onCancel={() => { setCurrentEvent(null) }} />
        }
      </menu>
      <div></div>
    </div>

  );
}

const mapStateToProps = (state) => {
  return {
    stmSlotCreateRequestMessage: state.stmSlotCreateRequestMessage
  };
};

export default connect(mapStateToProps)(Toolbox);
